<div class="w-100 h-100" *ngIf="!globalVariables.isPageSmall" [innerHTML]='html_desktop'>
</div>

<div class="w-100 h-100" *ngIf="globalVariables.isPageSmall" [innerHTML]='html_mobile'>
</div>